import examinationListParser from './examinationListParser';
import { ExaminationItemArray, ExaminationItemDataType } from './types';

const mapExaminationList = (
  data: ExaminationItemArray,
): ExaminationItemDataType => data.map(examinationListParser);

export default mapExaminationList;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/mapExaminationList.ts